import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Inicio', path: '/' },
    { name: 'Acreditación', path: '/acreditacion' },
    { name: 'Pilares', path: '/pilares' },
    { name: 'Recursos', path: '/recursos' },
    { name: 'Noticias', path: '/noticias' },
    { name: 'Contacto', path: '/contacto' }
  ];

  const [showTranslate, setShowTranslate] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center space-x-3">
            <div className="flex items-center space-x-3">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/logo_ups.png"}
                alt="UPS Logo"
                className="h-12 w-12 object-contain"
              />
              {/* Nuevo logo externo: granacertification */}
              <img
                src="https://granacertification.org/wp-content/uploads/2022/07/logo-header.jpg"
                alt="Grana Certification Logo"
                className="h-12 object-contain hidden sm:block"
                style={{ maxWidth: 180 }}
              />
            </div>
            <div className="hidden sm:block">
              <h1 className="text-lg font-bold text-burgundy-800">
                Acreditación Internacional <br /> Universidades Promotoras <br /> de la Salud
              </h1>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8 items-center">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${isActive(item.path)
                    ? 'text-burgundy-800 bg-burgundy-50 border-b-2 border-burgundy-600'
                    : 'text-gray-700 hover:text-burgundy-700 hover:bg-burgundy-50'
                  }`}
              >
                {item.name}
              </Link>
            ))}
            {/* Google Translate Icon */}
            <button
              className="flex items-center justify-center p-2 rounded-full hover:bg-gray-100 transition ml-2"
              aria-label="Seleccionar idioma"
              onClick={() => {
                setShowTranslate((v) => !v);
                setTimeout(() => {
                  const widget = document.getElementById('gt-widget');
                  if (widget) widget.classList.toggle('visible');
                }, 50);
              }}
              type="button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24"><path fill="#641e16" d="M12 2C6.477 2 2 6.477 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.523-4.477-10-10-10Zm0 2c.342 0 .68.022 1.012.064C12.36 4.5 12.184 5.5 12.07 6.5h-2.14c-.114-1-.29-2-.942-2.436A8.001 8.001 0 0 1 12 4Zm-3.5 1.618C9.5 6.5 9.686 7.5 9.8 8.5H6.5a8.03 8.03 0 0 1 2-2.882ZM4.062 10.5H8.5c.07 1 .21 2 .438 3H4.38a7.98 7.98 0 0 1-.318-3Zm.318 4.5h4.876c.228 1 .53 2 .97 2.882A8.03 8.03 0 0 1 4.38 15Zm1.882 3.382c.652-.436.828-1.436.942-2.436h2.14c.114 1 .29 2 .942 2.436A8.001 8.001 0 0 1 6.262 18.382ZM12 20a7.96 7.96 0 0 1-1.012-.064c-.332-.436-.508-1.436-.622-2.436h2.14c.114 1 .29 2 .942 2.436A7.96 7.96 0 0 1 12 20Zm3.5-1.618c-.652-.436-.828-1.436-.942-2.436h2.14c.114 1 .29 2 .942 2.436A8.03 8.03 0 0 1 15.5 18.382ZM19.938 13.5H15.5c-.07-1-.21-2-.438-3h4.058c.21.97.318 1.97.318 3Zm-.318-4.5h-4.876c-.228-1-.53-2-.97-2.882A8.03 8.03 0 0 1 19.62 9Zm-1.882-3.382c-.652.436-.828 1.436-.942 2.436h-2.14c-.114-1-.29-2-.942-2.436A8.001 8.001 0 0 1 17.738 5.618Z"/></svg>
            </button>
          </nav>
          {/* Desktop CTA Button 
          <Button className="hidden md:block bg-burgundy-700 hover:bg-burgundy-800 text-white">
            Iniciar Acreditación
          </Button> 
          */}

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-burgundy-700 hover:bg-gray-100"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-3 py-2 rounded-md text-sm font-medium ${isActive(item.path)
                      ? 'text-burgundy-800 bg-burgundy-50'
                      : 'text-gray-700 hover:text-burgundy-700 hover:bg-burgundy-50'
                    }`}
                >
                  {item.name}
                </Link>
              ))}
              <Button className="mt-4 bg-burgundy-700 hover:bg-burgundy-800 text-white">
                Iniciar Acreditación
              </Button>
            </nav>
          </div>

        )}
      </div>
    </header>
  );
};